<template lang="pug">
    .page(ref='galleryPage')
      section.pb-3
        b-container.text-center
          h1.h-alt OUR SEASONAL COLLECTION OF HAND-SELECTED PIECES
      section.p-0
        .container.pt-2
          b-form-row.row.my-0(inline)
              b-col.mb-2(cols="6", md="3")
                v-select.mb-1(:options="art_forms", label='title', :reduce="item => item.title", placeholder='FORM', v-model='filter.form')
              b-col.mb-2(cols="6", md="3")
                v-select.mb-1(:options="art_styles", label='title', :reduce="item => item.title", placeholder='STYLE', v-model='filter.style')
              b-col.mb-2(cols="6", md="3")
                v-select.mb-1(:options="artMedia", label='title', placeholder='MEDIUM', :reduce="item => item.title",  v-model='filter.medium')
              b-col.mb-2(cols="6", md="3")
                v-select.mb-1(:options="art_subjects", label='title', :reduce="item => item.title", placeholder='SUBJECT',  v-model='filter.subject')
          .row.p-3
            .col-4.pt-3.text-left.d-flex.align-items-center
              a.mx-2(@click="theatreMode = !theatreMode", :class="{ 'text-muted' : theatreMode }")
                font-awesome-icon(icon="th-large")
            .col-8.pt-3.text-right.d-flex.align-items-center.justify-content-end
              b-button.mx-1.btn-dark(@click="getArt(true)")
                loader(size="sm")
                span FILTER
              b-button.btn-outline.mx-1(@click='clearFilters') CLEAR
      masonry.gallery(:cols="{default: 4, 1000: 3, 700: 2, 400: 1}", :class="{'theatre-mode': theatreMode}")
        .piece(v-for="piece in art", :key='piece.id')
          a.btnOpenPiece(@click="openPiece(piece)", :class="piece.isDummy?'dummyPiece':'realPiece'")
            img.thumbnail(v-if="piece.thumbnail_url", :src="piece.thumbnail_url", @load="loaded(piece)", :alt="`${piece.title} by ${piece.artist}`")
            .placeholder-img.bg-light(v-if="piece.isDummy || !piece.loaded")
              b-spinner(type="grow")
          .info.p-2(v-if="!piece.isDummy")
            .row
              .col-8
                h6.text-dark {{ piece.artist }}
              .col-4.text-right
                h6.text-dark {{ formatRands(piece.price) }}
            .row
              .col-7
                p.my-1.text-dark {{ piece.title }}
              .col-5.text-right(v-if="piece.is_rentable")
                p.m-0.small {{ `Rent for ${formatRands(piece.price_rental)}/m` }}
            .row
              .col-10
                p.m-0.small {{ `${piece.height}x${piece.width}cm | ${piece.medium}` }}
              .col-2.text-right(v-if="account.loggedIn")
                a.favourite(v-if="!loveTest(piece)", @click="lovePiece(piece)")
                  font-awesome-icon(icon="heart")
                a.favourite.love(v-else="", @click="unlovePiece(piece)")
                  font-awesome-icon(icon="heart")

          .info.p-2(v-else="")
            .row
              .col-8
                content-loader(:height="20")
              .col-4
                content-loader(:height="40")
              .col-12
                content-loader(:height="12")
      section.text-center(v-if="!alert.loading && art.length === 0")
        nothing(text="NOTHING TO SHOW")
        //- img.logo(src="@/assets/images/branding/logo_icon_grey.svg")
        //- p.mt-5 No items
</template>

<script>
import standardMix from '@/mixins/standardMix';
import { apiService } from '@/services';
import Vue from 'vue';
// import router from '@/router';

export default {
  components: {
  },
  mixins: [standardMix],
  metaInfo: {
    title: 'Gallery',
  },
  data() {
    return {
      art_forms: [],
      art_media: [],
      art_styles: [],
      art_subjects: [],
      art: [],
      dummyArt: [
        { id: 'a', title: 'dummy', isDummy: true },
        { id: 'b', title: 'dummy', isDummy: true },
        { id: 'c', title: 'dummy', isDummy: true },
        { id: 'd', title: 'dummy', isDummy: true },
      ],
      lovedArt: null,
      showFilter: true,
      collapsed: true,
      filter: {
        form: '',
        style: '',
        medium: '',
        subject: '',
        artist_id: 'All',
        limit: 5,
        offset: 0,
        status: ['available', 'rented', 'reserved'],
        // price_high: 0,
      },
      noMore: true,
      theatreMode: false,
    };
  },
  computed: {
    artMedia() {
      const artForm = this.art_forms.find(item => item.title === this.filter.form);
      if (artForm) {
        const media = this.art_media.filter(item => item.art_form_id === artForm.id);
        return media;
      }
      return [];
    },
  },
  methods: {
    loaded(piece) {
      const newPiece = { ...piece };
      newPiece.loaded = true;
      const index = this.art.findIndex(item => item.id === piece.id);
      Vue.set(this.art, index, newPiece);
    },
    clearFilters() {
      this.filter.form = '';
      this.filter.style = '';
      this.filter.medium = '';
      this.filter.subject = '';
      this.filter.price_high = 'All';
      this.filter.artist_id = 'All';
      this.filter.offset = 0;
      this.getArt(true);
    },
    async getArt(reset) {
      try {
        if (reset) {
          this.art = [];
          this.filter.offset = 0;
          this.noMore = false;
        }
        this.loading();
        this.addDummies();
        if (this.account.loggedIn) {
          this.lovedArt = await apiService.getLovedArt(this.profileId, { limit: 100, offset: 0 });
          console.log(this.account.user);
          this.filter.is_test = this.account.user.is_test;
        }
        const newArt = await apiService.getArt(this.filter);
        if (newArt.length === 0) {
          this.noMore = true;
        }
        this.removeDummies();
        // eslint-disable-next-line no-restricted-syntax
        for (const item of newArt) {
          this.art.push(item);
        }
        this.clear();
        this.filter.offset += this.filter.limit;
      } catch (error) {
        this.error(error);
        this.noMore = true;
        this.removeDummies();
      }
    },
    openPiece(piece) {
      const routeData = this.$router.resolve({ name: 'Piece', params: { pieceId: piece.id, pieceTitle: this.kebabMe(piece.title) } });
      window.open(routeData.href, '_blank');
      // Navigate
      // router.push({ name: 'Piece', params: { pieceId: piece.id, pieceTitle: this.kebabMe(piece.title) } });
    },
    async lovePiece(piece) {
      try {
        await apiService.lovePiece(this.profileId, piece.id);
        this.lovedArt.push(piece);
      } catch (error) {
        this.error('Something went wrong');
      }
    },
    async unlovePiece(piece) {
      try {
        await apiService.unlovePiece(this.profileId, piece.id);
        this.lovedArt = this.lovedArt.filter(item => item.id !== piece.id);
      } catch (error) {
        this.error('Something went wrong');
      }
    },
    loveTest(piece) {
      return this.lovedArt.some(item => item.id === piece.id);
    },
    onScroll() {
      const scrollBottom = document.documentElement.scrollTop + document.documentElement.clientHeight;
      const galleryHeight = this.$refs.galleryPage.clientHeight;
      if ((scrollBottom >= galleryHeight) && !this.alert.loading) {
        this.getArt();
      }
    },
    addDummies() {
      this.removeDummies();
      this.art.push(...this.dummyArt);
    },
    removeDummies() {
      this.art = this.art.filter(item => !item.isDummy);
    },
  },
  watch: {
    noMore(done) {
      if (done) {
        window.removeEventListener('scroll', this.onScroll);
      } else {
        window.addEventListener('scroll', this.onScroll);
      }
    },
  },
  async created() {
    // Process route param filters
    const { form, style, medium, subject, artist } = this.$route.query;
    this.filter.form = this.unKebabMe(form) || '';
    this.filter.medium = this.unKebabMe(medium) || '';
    this.filter.style = this.unKebabMe(style) || '';
    this.filter.subject = this.unKebabMe(subject) || '';
    this.filter.artist_id = artist || '';
    this.noMore = false;
    // TEMP Only loading art for logged in user
    await this.getArt();
    this.art_forms = await apiService.getResource('art_form');
    this.art_media = await apiService.getResource('art_medium');
    this.art_styles = await apiService.getResource('art_style');
    this.art_subjects = await apiService.getResource('art_subject');
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },
};
</script>

<style lang="scss" scoped>

  .v-select {
    text-transform: uppercase;
    // border: 1px solid black;
    font-family: $font-body;
    font-size: 16px;
    border: none;
    .vs__dropdown-toggle {
      border: none !important;
    }
  }
  .gallery {
    background-color: white;
    padding: 10px;
    transition: all ease-in 0.5s;
    .piece {
      transition: all ease-in 0.5s;
      margin: 15px;
      opacity: 1;
      .thumbnail {
        width: 100%;
      }
      .placeholder-img {
        width: 100%;
        height: 300px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .info {
        transition: all ease-in 0.5s;
        .favourite {
          color: lightgray;
          &.love {
            // color: rgb(250, 195, 0);
            color: black;
          }
        }
      }
    }
    &.theatre-mode {
      padding: 0;
      .piece {
        margin: 0;
      }
      .info {
        max-height: 0;
        overflow: hidden;
        padding: 0 !important;
      }
    }
  }
  .logo {
    width: 150px;
  }

</style>



// WEBPACK FOOTER //
// src/components/views/Gallery.vue